import { repository } from "repositories";
import { useSWRInfiniteWithScroller } from "shared/hooks/useSWRInfiniteWithScroller";
import { GetAnnouncementListRes } from "shared/types";
import { getSwrInfiniteKey } from "shared/lib/swr/utils/getSwrInfiniteKey";

export const useAnnouncementList = () => {
  const swr = repository.announcement.getList();

  const { data, ...rest } = useSWRInfiniteWithScroller(
    getSwrInfiniteKey<GetAnnouncementListRes>({
      path: swr.path,
    }),
    swr.fetcher,
    { fallbackData: swr.fallbackData }
  );

  return {
    announcements: data.flatMap((d) => d.announcements),
    ...rest,
  };
};
